import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyLeavesComponent } from './my-leaves/my-leaves.component';
import { MaterialModule } from '../material.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OfficialDetailsComponent } from './official-details/official-details.component';
import { CtcDetailsComponent } from './ctc-details/ctc-details.component';
import { PersonalDetailsComponent } from './personal-details/personal-details.component';
import { CommitmentLetterComponent } from './commitment-letter/commitment-letter.component';
import { ContractLetterComponent } from './contract-letter/contract-letter.component';



@NgModule({
  declarations: [MyLeavesComponent, OfficialDetailsComponent, CtcDetailsComponent, PersonalDetailsComponent, CommitmentLetterComponent, ContractLetterComponent],
  imports: [
    CommonModule,
    MaterialModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class UserDetailsModule { }
